import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatMeasurement, MeasurementKind } from "./measurements";
import { useMeasurementSettings } from "./useMeasurementSettings";

export function MeasurementValue({ value, kind }: {
  value: number | null | undefined;
  kind: MeasurementKind;
}) {
  const { i18n } = useTranslation();
  const { configuration } = useMeasurementSettings();
  const locale = i18n.resolvedLanguage?.startsWith("en") ? "en-US" : "fr-FR";
  return <>{value == null ? "—" : formatMeasurement(value, kind, configuration, locale)}</>;
}

export function LabeledMeasurementValue({ label, value, kind }: {
  label: string;
  value: number | null | undefined;
  kind: MeasurementKind;
}) {
  return (
    <div>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
      <Typography fontWeight={700}>
        <MeasurementValue value={value} kind={kind} />
      </Typography>
    </div>
  );
}
